var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1420,
    height: 918,
    viewBox: "0 0 1420 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_1059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1420,
    height: 918,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.438,
    y: -70.0674,
    width: 1155,
    height: 1238,
    fill: "#FF6C99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349.562 -6.56793C-349.562 -6.56793 1160.53 -456.182 875.92 33.6231C591.309 523.429 877.026 695.885 679.836 950.686C482.647 1205.49 -373.562 1170.43 -431.062 1170.43C-488.562 1170.43 -349.562 -6.56793 -349.562 -6.56793Z",
    fill: "#3B4B80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.948,
    cy: 98.0146,
    r: 2.23161,
    transform: "rotate(-44.9299 16.948 98.0146)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.7045,
    cy: 117.229,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.7045 117.229)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.35196,
    cy: 80.2509,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.35196 80.2509)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1631,
    cy: 116.667,
    r: 2.23161,
    transform: "rotate(-44.9299 36.1631 116.667)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.893,
    cy: 171.736,
    r: 2.23161,
    transform: "rotate(-44.9299 92.893 171.736)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.0705,
    cy: 143.758,
    r: 2.23161,
    transform: "rotate(-44.9299 64.0705 143.758)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.8,
    cy: 198.827,
    r: 2.23161,
    transform: "rotate(-44.9299 120.8 198.827)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.142,
    cy: 155.098,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.142 155.098)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.588,
    cy: 210.166,
    r: 2.23161,
    transform: "rotate(-44.9299 55.588 210.166)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.7655,
    cy: 182.187,
    r: 2.23161,
    transform: "rotate(-44.9299 26.7655 182.187)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4954,
    cy: 237.257,
    r: 2.23161,
    transform: "rotate(-44.9299 83.4954 237.257)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5105,
    cy: 135.882,
    r: 2.23161,
    transform: "rotate(-44.9299 17.5105 135.882)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.2405,
    cy: 190.951,
    r: 2.23161,
    transform: "rotate(-44.9299 74.2405 190.951)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.418,
    cy: 162.973,
    r: 2.23161,
    transform: "rotate(-44.9299 45.418 162.973)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.148,
    cy: 218.042,
    r: 2.23161,
    transform: "rotate(-44.9299 102.148 218.042)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.9355,
    cy: 229.382,
    r: 2.23161,
    transform: "rotate(-44.9299 36.9355 229.382)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.2829,
    cy: 248.597,
    r: 2.23161,
    transform: "rotate(-44.9299 18.2829 248.597)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.113,
    cy: 201.402,
    r: 2.23161,
    transform: "rotate(-44.9299 8.113 201.402)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.8429,
    cy: 256.472,
    r: 2.23161,
    transform: "rotate(-44.9299 64.8429 256.472)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.6692,
    cy: 304.954,
    r: 2.23161,
    transform: "rotate(-44.9299 18.6692 304.954)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.1905,
    cy: 275.686,
    r: 2.23161,
    transform: "rotate(-44.9299 46.1905 275.686)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.0166887,
    cy: 324.169,
    r: 2.23161,
    transform: "rotate(-44.9299 0.0166887 324.169)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.62179,
    cy: 107.622,
    r: 2.23161,
    transform: "rotate(-44.9299 7.62179 107.622)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8368,
    cy: 126.275,
    r: 2.23161,
    transform: "rotate(-44.9299 26.8368 126.275)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5667,
    cy: 181.344,
    r: 2.23161,
    transform: "rotate(-44.9299 83.5667 181.344)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.7442,
    cy: 153.365,
    r: 2.23161,
    transform: "rotate(-44.9299 54.7442 153.365)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.474,
    cy: 208.435,
    r: 2.23161,
    transform: "rotate(-44.9299 111.474 208.435)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.2617,
    cy: 219.774,
    r: 2.23161,
    transform: "rotate(-44.9299 46.2617 219.774)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.0879777,
    cy: 268.256,
    r: 2.23161,
    transform: "rotate(-44.9299 0.0879777 268.256)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6092,
    cy: 238.988,
    r: 2.23161,
    transform: "rotate(-44.9299 27.6092 238.988)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.4392,
    cy: 191.796,
    r: 2.23161,
    transform: "rotate(-44.9299 17.4392 191.796)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.1692,
    cy: 246.864,
    r: 2.23161,
    transform: "rotate(-44.9299 74.1692 246.864)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.9954,
    cy: 295.346,
    r: 2.23161,
    transform: "rotate(-44.9299 27.9954 295.346)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.21329,
    cy: 211.01,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.21329 211.01)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5167,
    cy: 266.079,
    r: 2.23161,
    transform: "rotate(-44.9299 55.5167 266.079)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.34292,
    cy: 314.561,
    r: 2.23161,
    transform: "rotate(-44.9299 9.34292 314.561)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.18423,
    cy: 145.489,
    r: 2.23161,
    transform: "rotate(-44.9299 8.18423 145.489)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9142,
    cy: 200.559,
    r: 2.23161,
    transform: "rotate(-44.9299 64.9142 200.559)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.0917,
    cy: 172.58,
    r: 2.23161,
    transform: "rotate(-44.9299 36.0917 172.58)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.8217,
    cy: 227.649,
    r: 2.23161,
    transform: "rotate(-44.9299 92.8217 227.649)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6092,
    cy: 238.988,
    r: 2.23161,
    transform: "rotate(-44.9299 27.6092 238.988)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.95669,
    cy: 258.204,
    r: 2.23161,
    transform: "rotate(-44.9299 8.95669 258.204)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.21329,
    cy: 211.01,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.21329 211.01)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5167,
    cy: 266.079,
    r: 2.23161,
    transform: "rotate(-44.9299 55.5167 266.079)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.34292,
    cy: 314.561,
    r: 2.23161,
    transform: "rotate(-44.9299 9.34292 314.561)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8642,
    cy: 285.295,
    r: 2.23161,
    transform: "rotate(-44.9299 36.8642 285.295)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5555,
    cy: 107.341,
    r: 2.23161,
    transform: "rotate(-44.9299 26.5555 107.341)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.2855,
    cy: 162.41,
    r: 2.23161,
    transform: "rotate(-44.9299 83.2855 162.41)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.463,
    cy: 134.432,
    r: 2.23161,
    transform: "rotate(-44.9299 54.463 134.432)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.193,
    cy: 189.501,
    r: 2.23161,
    transform: "rotate(-44.9299 111.193 189.501)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.9805,
    cy: 200.84,
    r: 2.23161,
    transform: "rotate(-44.9299 45.9805 200.84)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.158,
    cy: 172.861,
    r: 2.23161,
    transform: "rotate(-44.9299 17.158 172.861)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.888,
    cy: 227.931,
    r: 2.23161,
    transform: "rotate(-44.9299 73.888 227.931)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.90304,
    cy: 126.556,
    r: 2.23161,
    transform: "rotate(-44.9299 7.90304 126.556)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.633,
    cy: 181.625,
    r: 2.23161,
    transform: "rotate(-44.9299 64.633 181.625)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8105,
    cy: 153.646,
    r: 2.23161,
    transform: "rotate(-44.9299 35.8105 153.646)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5405,
    cy: 208.716,
    r: 2.23161,
    transform: "rotate(-44.9299 92.5405 208.716)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.328,
    cy: 220.056,
    r: 2.23161,
    transform: "rotate(-44.9299 27.328 220.056)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.67544,
    cy: 239.27,
    r: 2.23161,
    transform: "rotate(-44.9299 8.67544 239.27)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.49454,
    cy: 192.076,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.49454 192.076)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2354,
    cy: 247.145,
    r: 2.23161,
    transform: "rotate(-44.9299 55.2354 247.145)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.06167,
    cy: 295.628,
    r: 2.23161,
    transform: "rotate(-44.9299 9.06167 295.628)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5829,
    cy: 266.36,
    r: 2.23161,
    transform: "rotate(-44.9299 36.5829 266.36)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.798,
    cy: 89.1328,
    r: 2.23161,
    transform: "rotate(-44.9299 7.798 89.1328)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.313,
    cy: 125.55,
    r: 2.23161,
    transform: "rotate(-44.9299 45.313 125.55)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.043,
    cy: 180.619,
    r: 2.23161,
    transform: "rotate(-44.9299 102.043 180.619)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.2205,
    cy: 152.64,
    r: 2.23161,
    transform: "rotate(-44.9299 73.2205 152.64)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.95,
    cy: 207.709,
    r: 2.23161,
    transform: "rotate(-44.9299 129.95 207.709)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00796,
    cy: 163.979,
    r: 2.23161,
    transform: "rotate(-44.9299 8.00796 163.979)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.738,
    cy: 219.049,
    r: 2.23161,
    transform: "rotate(-44.9299 64.738 219.049)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9155,
    cy: 191.07,
    r: 2.23161,
    transform: "rotate(-44.9299 35.9155 191.07)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6455,
    cy: 246.14,
    r: 2.23161,
    transform: "rotate(-44.9299 92.6455 246.14)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.6605,
    cy: 144.765,
    r: 2.23161,
    transform: "rotate(-44.9299 26.6605 144.765)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.3905,
    cy: 199.833,
    r: 2.23161,
    transform: "rotate(-44.9299 83.3905 199.833)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.568,
    cy: 171.854,
    r: 2.23161,
    transform: "rotate(-44.9299 54.568 171.854)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.298,
    cy: 226.924,
    r: 2.23161,
    transform: "rotate(-44.9299 111.298 226.924)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0855,
    cy: 238.264,
    r: 2.23161,
    transform: "rotate(-44.9299 46.0855 238.264)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.0882918,
    cy: 286.745,
    r: 2.23161,
    transform: "rotate(-44.9299 -0.0882918 286.745)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.4329,
    cy: 257.478,
    r: 2.23161,
    transform: "rotate(-44.9299 27.4329 257.478)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.263,
    cy: 210.285,
    r: 2.23161,
    transform: "rotate(-44.9299 17.263 210.285)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9929,
    cy: 265.353,
    r: 2.23161,
    transform: "rotate(-44.9299 73.9929 265.353)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8192,
    cy: 313.836,
    r: 2.23161,
    transform: "rotate(-44.9299 27.8192 313.836)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.38956,
    cy: 229.5,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.38956 229.5)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.3405,
    cy: 284.569,
    r: 2.23161,
    transform: "rotate(-44.9299 55.3405 284.569)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.16665,
    cy: 333.051,
    r: 2.23161,
    transform: "rotate(-44.9299 9.16665 333.051)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.2293,
    cy: 116.948,
    r: 2.23161,
    transform: "rotate(-44.9299 17.2293 116.948)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9593,
    cy: 172.018,
    r: 2.23161,
    transform: "rotate(-44.9299 73.9593 172.018)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1367,
    cy: 144.039,
    r: 2.23161,
    transform: "rotate(-44.9299 45.1367 144.039)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.867,
    cy: 199.108,
    r: 2.23161,
    transform: "rotate(-44.9299 101.867 199.108)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6542,
    cy: 210.448,
    r: 2.23161,
    transform: "rotate(-44.9299 36.6542 210.448)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.0017,
    cy: 229.662,
    r: 2.23161,
    transform: "rotate(-44.9299 18.0017 229.662)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.83175,
    cy: 182.469,
    r: 2.23161,
    transform: "rotate(-44.9299 7.83175 182.469)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5617,
    cy: 237.538,
    r: 2.23161,
    transform: "rotate(-44.9299 64.5617 237.538)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.388,
    cy: 286.02,
    r: 2.23161,
    transform: "rotate(-44.9299 18.388 286.02)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.9092,
    cy: 256.753,
    r: 2.23161,
    transform: "rotate(-44.9299 45.9092 256.753)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.264561,
    cy: 305.234,
    r: 2.23161,
    transform: "rotate(-44.9299 -0.264561 305.234)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.42325,
    cy: 136.163,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.42325 136.163)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.3067,
    cy: 191.232,
    r: 2.23161,
    transform: "rotate(-44.9299 55.3067 191.232)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.4843,
    cy: 163.254,
    r: 2.23161,
    transform: "rotate(-44.9299 26.4843 163.254)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.2142,
    cy: 218.323,
    r: 2.23161,
    transform: "rotate(-44.9299 83.2142 218.323)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.0017,
    cy: 229.662,
    r: 2.23161,
    transform: "rotate(-44.9299 18.0017 229.662)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.650792,
    cy: 248.878,
    r: 2.23161,
    transform: "rotate(-44.9299 -0.650792 248.878)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.9092,
    cy: 256.753,
    r: 2.23161,
    transform: "rotate(-44.9299 45.9092 256.753)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.264561,
    cy: 305.234,
    r: 2.23161,
    transform: "rotate(-44.9299 -0.264561 305.234)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2567,
    cy: 275.969,
    r: 2.23161,
    transform: "rotate(-44.9299 27.2567 275.969)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.52823,
    cy: 98.7392,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.52823 98.7392)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9867,
    cy: 135.156,
    r: 2.23161,
    transform: "rotate(-44.9299 35.9867 135.156)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.7168,
    cy: 190.227,
    r: 2.23161,
    transform: "rotate(-44.9299 92.7168 190.227)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.8943,
    cy: 162.247,
    r: 2.23161,
    transform: "rotate(-44.9299 63.8943 162.247)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.624,
    cy: 217.316,
    r: 2.23161,
    transform: "rotate(-44.9299 120.624 217.316)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1.31827,
    cy: 173.587,
    r: 2.23161,
    transform: "rotate(-44.9299 -1.31827 173.587)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4117,
    cy: 228.656,
    r: 2.23161,
    transform: "rotate(-44.9299 55.4117 228.656)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.23794,
    cy: 277.138,
    r: 2.23161,
    transform: "rotate(-44.9299 9.23794 277.138)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.7592,
    cy: 247.871,
    r: 2.23161,
    transform: "rotate(-44.9299 36.7592 247.871)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5892,
    cy: 200.677,
    r: 2.23161,
    transform: "rotate(-44.9299 26.5892 200.677)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.3192,
    cy: 255.747,
    r: 2.23161,
    transform: "rotate(-44.9299 83.3192 255.747)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1454,
    cy: 304.228,
    r: 2.23161,
    transform: "rotate(-44.9299 37.1454 304.228)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.93673,
    cy: 219.893,
    r: 2.23161,
    transform: "rotate(-44.9299 7.93673 219.893)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.6667,
    cy: 274.962,
    r: 2.23161,
    transform: "rotate(-44.9299 64.6667 274.962)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.4929,
    cy: 323.443,
    r: 2.23161,
    transform: "rotate(-44.9299 18.4929 323.443)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3343,
    cy: 154.372,
    r: 2.23161,
    transform: "rotate(-44.9299 17.3343 154.372)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.0642,
    cy: 209.441,
    r: 2.23161,
    transform: "rotate(-44.9299 74.0642 209.441)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.2417,
    cy: 181.463,
    r: 2.23161,
    transform: "rotate(-44.9299 45.2417 181.463)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.972,
    cy: 236.531,
    r: 2.23161,
    transform: "rotate(-44.9299 101.972 236.531)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.7592,
    cy: 247.871,
    r: 2.23161,
    transform: "rotate(-44.9299 36.7592 247.871)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.1067,
    cy: 267.086,
    r: 2.23161,
    transform: "rotate(-44.9299 18.1067 267.086)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.93673,
    cy: 219.893,
    r: 2.23161,
    transform: "rotate(-44.9299 7.93673 219.893)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.6667,
    cy: 274.962,
    r: 2.23161,
    transform: "rotate(-44.9299 64.6667 274.962)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.4929,
    cy: 323.443,
    r: 2.23161,
    transform: "rotate(-44.9299 18.4929 323.443)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0142,
    cy: 294.177,
    r: 2.23161,
    transform: "rotate(-44.9299 46.0142 294.177)",
    fill: "#4D5F95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.159581,
    cy: 342.658,
    r: 2.23161,
    transform: "rotate(-44.9299 -0.159581 342.658)",
    fill: "#4D5F95"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1184.82,
    cy: 840.448,
    r: 2.39647,
    transform: "rotate(-43.8968 1184.82 840.448)",
    fill: "#E1698E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1224.39,
    cy: 880.275,
    r: 2.39647,
    transform: "rotate(-43.8968 1224.39 880.275)",
    fill: "#E1698E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1144.02,
    cy: 880.988,
    r: 2.39647,
    transform: "rotate(-43.8968 1144.02 880.988)",
    fill: "#E1698E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1164.42,
    cy: 860.718,
    r: 2.39647,
    transform: "rotate(-43.8968 1164.42 860.718)",
    fill: "#E1698E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1204,
    cy: 900.545,
    r: 2.39647,
    transform: "rotate(-43.8968 1204 900.545)",
    fill: "#E1698E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123.62,
    cy: 901.258,
    r: 2.39647,
    transform: "rotate(-43.8968 1123.62 901.258)",
    fill: "#E1698E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1205.09,
    cy: 860.847,
    r: 2.39647,
    transform: "rotate(-43.8968 1205.09 860.847)",
    fill: "#E1698E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1244.66,
    cy: 900.675,
    r: 2.39647,
    transform: "rotate(-43.8968 1244.66 900.675)",
    fill: "#E1698E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1164.29,
    cy: 901.388,
    r: 2.39647,
    transform: "rotate(-43.8968 1164.29 901.388)",
    fill: "#E1698E"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1184.69,
    cy: 881.117,
    r: 2.39647,
    transform: "rotate(-43.8968 1184.69 881.117)",
    fill: "#E1698E"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1174.62,
    cy: 850.583,
    r: 2.39647,
    transform: "rotate(-43.8968 1174.62 850.583)",
    fill: "#E1698E"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1214.19,
    cy: 890.41,
    r: 2.39647,
    transform: "rotate(-43.8968 1214.19 890.41)",
    fill: "#E1698E"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1133.82,
    cy: 891.124,
    r: 2.39647,
    transform: "rotate(-43.8968 1133.82 891.124)",
    fill: "#E1698E"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1113.42,
    cy: 911.393,
    r: 2.39647,
    transform: "rotate(-43.8968 1113.42 911.393)",
    fill: "#E1698E"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1154.22,
    cy: 870.853,
    r: 2.39647,
    transform: "rotate(-43.8968 1154.22 870.853)",
    fill: "#E1698E"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1193.8,
    cy: 910.68,
    r: 2.39647,
    transform: "rotate(-43.8968 1193.8 910.68)",
    fill: "#E1698E"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1113.42,
    cy: 911.393,
    r: 2.39647,
    transform: "rotate(-43.8968 1113.42 911.393)",
    fill: "#E1698E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1194.89,
    cy: 870.982,
    r: 2.39647,
    transform: "rotate(-43.8968 1194.89 870.982)",
    fill: "#E1698E"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1234.46,
    cy: 910.809,
    r: 2.39647,
    transform: "rotate(-43.8968 1234.46 910.809)",
    fill: "#E1698E"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1154.09,
    cy: 911.522,
    r: 2.39647,
    transform: "rotate(-43.8968 1154.09 911.522)",
    fill: "#E1698E"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1174.49,
    cy: 891.252,
    r: 2.39647,
    transform: "rotate(-43.8968 1174.49 891.252)",
    fill: "#E1698E"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1194.95,
    cy: 850.648,
    r: 2.39647,
    transform: "rotate(-43.8968 1194.95 850.648)",
    fill: "#E1698E"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1234.53,
    cy: 890.475,
    r: 2.39647,
    transform: "rotate(-43.8968 1234.53 890.475)",
    fill: "#E1698E"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1154.16,
    cy: 891.187,
    r: 2.39647,
    transform: "rotate(-43.8968 1154.16 891.187)",
    fill: "#E1698E"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1174.56,
    cy: 870.918,
    r: 2.39647,
    transform: "rotate(-43.8968 1174.56 870.918)",
    fill: "#E1698E"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1214.13,
    cy: 910.745,
    r: 2.39647,
    transform: "rotate(-43.8968 1214.13 910.745)",
    fill: "#E1698E"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1133.76,
    cy: 911.458,
    r: 2.39647,
    transform: "rotate(-43.8968 1133.76 911.458)",
    fill: "#E1698E"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1214.74,
    cy: 870.561,
    r: 2.39647,
    transform: "rotate(-43.8968 1214.74 870.561)",
    fill: "#E1698E"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1254.32,
    cy: 910.388,
    r: 2.39647,
    transform: "rotate(-43.8968 1254.32 910.388)",
    fill: "#E1698E"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 1173.94,
    cy: 911.101,
    r: 2.39647,
    transform: "rotate(-43.8968 1173.94 911.101)",
    fill: "#E1698E"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1194.34,
    cy: 890.831,
    r: 2.39647,
    transform: "rotate(-43.8968 1194.34 890.831)",
    fill: "#E1698E"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1184.76,
    cy: 860.782,
    r: 2.39647,
    transform: "rotate(-43.8968 1184.76 860.782)",
    fill: "#E1698E"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1224.33,
    cy: 900.609,
    r: 2.39647,
    transform: "rotate(-43.8968 1224.33 900.609)",
    fill: "#E1698E"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1143.96,
    cy: 901.323,
    r: 2.39647,
    transform: "rotate(-43.8968 1143.96 901.323)",
    fill: "#E1698E"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1164.36,
    cy: 881.053,
    r: 2.39647,
    transform: "rotate(-43.8968 1164.36 881.053)",
    fill: "#E1698E"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 1204.54,
    cy: 880.696,
    r: 2.39647,
    transform: "rotate(-43.8968 1204.54 880.696)",
    fill: "#E1698E"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1184.14,
    cy: 900.967,
    r: 2.39647,
    transform: "rotate(-43.8968 1184.14 900.967)",
    fill: "#E1698E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1420,
    height: 918,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundoLogin);
export default __webpack_public_path__ + "static/media/fundoLogin.9d82fb79a6d4fd5a0ad0189d96583a9b.svg";
export { ForwardRef as ReactComponent };